import { AccountNyukyokeiyakuViewModel } from "./AccountNyukyokeiyakuViewModel";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
import { userType } from "~/extensions/utils/DefineTypes";
export class AccountDetailViewModel {
    constructor(data = null) {
        if (!data) {
            return;
        }
        this.model = data;
        this.loginId = data.loginId;
        this.email = data.email;
        this.userCd = data.userCd;
        this.userName = data.userName;
        this.userKb = data.userKb;
        this.tel = data.tel;
        this.kankatsuKb = data.kankatsuKb;
        this.nyukyokeiyakuList = data.nyukyokeiyakuList.map(x => new AccountNyukyokeiyakuViewModel(x));
        this.isRegisteredAccount = !isNullOrUndefined(data.loginId) && data.loginId !== "";
    }
    model = null;
    loginId = "";
    password = "";
    email = "";
    smsNotificationType = null;
    userCd = null;
    userName = "";
    userKb = -1;
    tel = "";
    kankatsuKb = null;
    nyukyokeiyakuList = [
        {
            model: null,
            nyukyokeiyakuNo: null,
            nyukyokeiyakuName: "",
            buknName: "",
            roomNo: ""
        }
    ];
    isRegisteredAccount = false;
    get isMultipleNyukyokeiyaku() {
        return this.nyukyokeiyakuList.length > 1;
    }
    /** 個人の場合は携帯電話番号、法人の場合は連絡先 */
    get telLabel() {
        return this.isKojin ? "携帯電話番号" : "連絡先";
    }
    /** number型の契約区分に応じた区部のラベルを返す */
    get userKbLabel() {
        return this.isKojin ? "個人" : "法人";
    }
    /** 契約区分が個人かどうか */
    get isKojin() {
        return this.userKb === userType.Kojin;
    }
    /** 契約区分が法人かどうか */
    get isHojin() {
        return this.userKb === userType.hojin;
    }
    /** number型の管轄区分に応じた区部のラベルを返す */
    get kankatsuKbLabel() {
        return this.isChubu ? "中部" : "関東";
    }
    /** 管轄区分が中部かどうか */
    get isChubu() {
        return this.kankatsuKb === 0;
    }
    /** 管轄区分が関東かどうか */
    get isKanto() {
        return this.kankatsuKb === 1;
    }
    /** 値の変更が行われたかどうか */
    get isDirty() {
        return this.model != null && (this.password !== "" || this.email !== this.model.email || this.tel !== this.model.tel);
    }
}
